// prova/videoBot.ts — il "video" del bot nella partita di prova: una faccina disegnata e animata (respira, sbatte
// le palpebre, ride quando il server dice che ha riso, sparisce quando è "fuori inquadratura"). Nessuna rete: è un
// MediaStream creato da un canvas, usato al posto del video dell'avversario.
export type StatoBot = "neutro" | "ride" | "assente";

export interface VideoBot {
  flusso: MediaStream;
  imposta(stato: StatoBot): void;
  ferma(): void;
}

const LARGHEZZA = 360;
const ALTEZZA = 480;
const FPS = 20;

export function creaVideoBot(colori: { sfondo: string; faccia: string; tratto: string }): VideoBot {
  // Tema in bianco e nero (accento = testo): la faccia prende il colore dello sfondo, i tratti restano visibili.
  if (colori.faccia.toLowerCase() === colori.tratto.toLowerCase()) colori = { ...colori, faccia: colori.sfondo };
  const tela = document.createElement("canvas");
  tela.width = LARGHEZZA;
  tela.height = ALTEZZA;
  const ctx = tela.getContext("2d")!;
  let stato: StatoBot = "neutro";
  let fermo = false;
  const inizio = performance.now();

  const disegna = () => {
    if (fermo) return;
    const t = (performance.now() - inizio) / 1000;
    ctx.fillStyle = colori.sfondo;
    ctx.fillRect(0, 0, LARGHEZZA, ALTEZZA);
    if (stato !== "assente") {
      const ride = stato === "ride";
      const scossa = ride ? Math.sin(t * 22) * 6 : Math.sin(t * 1.3) * 3;
      const cx = LARGHEZZA / 2 + scossa;
      const cy = ALTEZZA / 2 + Math.sin(t * 2) * 4;
      ctx.fillStyle = colori.faccia;
      ctx.strokeStyle = colori.tratto;
      ctx.lineWidth = 8;
      ctx.beginPath();
      ctx.ellipse(cx, cy, 120, 150, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
      // occhi: sbattono ogni ~3 s; ridendo diventano due archi
      const chiusi = ride || t % 3.2 < 0.12;
      ctx.fillStyle = colori.tratto;
      for (const dx of [-45, 45]) {
        ctx.beginPath();
        if (chiusi) {
          ctx.arc(cx + dx, cy - 30, 16, Math.PI * 1.1, Math.PI * 1.9);
          ctx.stroke();
        } else {
          ctx.arc(cx + dx, cy - 30, 12, 0, Math.PI * 2);
          ctx.fill();
        }
      }
      // bocca: dritta, o spalancata che sussulta
      ctx.beginPath();
      if (ride) {
        const apertura = 40 + Math.abs(Math.sin(t * 14)) * 25;
        ctx.ellipse(cx, cy + 60, 55, apertura / 2, 0, 0, Math.PI * 2);
        ctx.fill();
      } else {
        ctx.moveTo(cx - 45, cy + 60);
        ctx.quadraticCurveTo(cx, cy + 66, cx + 45, cy + 58);
        ctx.stroke();
      }
    }
  };
  const id = setInterval(disegna, 1000 / FPS);
  disegna();
  const flusso = tela.captureStream(FPS);
  return {
    flusso,
    imposta: (s) => {
      stato = s;
    },
    ferma: () => {
      fermo = true;
      clearInterval(id);
      flusso.getTracks().forEach((tr) => tr.stop());
    },
  };
}
